module.exports = __webpack_public_path__ + "img/handmade-close-circle__dark.0268d91b.svg";